<!-- 选择记工类型：点工/包工-->
<template>
  <div>
    <el-button class="work_btn" @click="openRecord">记工</el-button>

    <el-dialog
      title="请选择："
      :visible.sync="selectStatisticsType"
      width="400px"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>选择记工类型：</div>
      <div class="content">
        <div @click="workRecordNo='';addPointworkVisible = true" class="gong_type_item">
          <img src="@/assets/record/diangoong.png" alt="">
          点工
        </div>
        <div @click="workRecordNo='';addBaoworkVisible = true" class="gong_type_item">
          <img src="@/assets/record/baogong.png" alt="">
          包工
        </div>
      </div>
    </el-dialog>


    <!-- 新增点工 -->
    <addPointWorkDialog :visible.sync="addPointworkVisible" :project="project" :workRecordNo="workRecordNo"
                        @close="close"></addPointWorkDialog>

    <!--  新增包工  -->
    <addBaoWorkDialog :visible.sync="addBaoworkVisible" :project="project" :workRecordNo="workRecordNo"
                      @close="close"></addBaoWorkDialog>

    <!--  新增项目  -->
    <ProjectEdit ref="projectEdit" @editend="(v)=>{$emit('close',v);selectStatisticsType=true}"></ProjectEdit>
  </div>
</template>

<script>
export default {
  name: "statisticsBtn",
  components: {
    addPointWorkDialog: () => import("./components/addPointWorkDialog.vue"), // 新增点工弹窗
    addBaoWorkDialog: () => import("./components/addBaoWorkDialog.vue"), // 新增包工弹窗
    ProjectEdit: () => import("@/views/record/components/projectEdit.vue") // 新增项目
  },
  props: {
    project: {
      type: [Object, undefined]
    },
  },
  data() {
    return {
      selectStatisticsType: false,
      addPointworkVisible: false,
      addBaoworkVisible: false,
      workRecordNo: "", // 流水no
      day:null // 选中的日期对象
    }
  },
  methods: {
    open(project) {
      this.workRecordNo = project.workRecordNo
      if (project.recordType === '1') {
        this.addPointworkVisible = true
      } else {
        this.addBaoworkVisible = true
      }
    },
    /**
     * 班组记工编辑
     * @param arr {Array} 由多工人组成的单个记工数组
     */
    openarr(arr=[]){
      let project=arr[0]?{...arr[0]}:{}
      let workNoList=[]
      arr.forEach(v=>{
        workNoList.push(v.settleWorkerNo)
      })
      project.workNoList=workNoList
      this.project=project
      this.open(project)
    },
    openRecord() {
      if (this.project) {
        this.selectStatisticsType = true
      } else {
        this.$refs.projectEdit.open()
      }
    },
    // 保存成功，关闭所有弹窗
    close() {
      this.selectStatisticsType = false
      this.addPointworkVisible = false
      this.addBaoworkVisible = false
      this.$emit('close')
    }
  },
  watch:{
    selectStatisticsType(val){
      if(!val){
        this.day=null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-button--default{
  &:hover{
    background: #fff;
  }
}
.content {
  padding: 30px 74px 0;
  display: flex;
  justify-content: space-between;
  text-align: center;

  img {
    margin-bottom: 14px;
    width: 58px;
    height: 58px;
  }

  .gong_type_item {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    color: #333;
  }
}

.work_btn {
  color: #B79255;
  border: 1px solid #B79255;
}
</style>
